__turbopack_context__.v({
  "component": "style-module-scss-module__D_i4kW__component",
  "faq-content": "style-module-scss-module__D_i4kW__faq-content",
  "faq-details": "style-module-scss-module__D_i4kW__faq-details",
  "faq-header": "style-module-scss-module__D_i4kW__faq-header",
  "toggle-icon": "style-module-scss-module__D_i4kW__toggle-icon",
});
